import { render, staticRenderFns } from "./ModalStatistics.vue?vue&type=template&id=5ed345c0&scoped=true&"
import script from "./ModalStatistics.vue?vue&type=script&lang=js&"
export * from "./ModalStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ModalStatistics.vue?vue&type=style&index=0&id=5ed345c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed345c0",
  null
  
)

export default component.exports